import { createTheme } from "@mui/material"
import overrides from "./overrides"
import palette from "./palette"
import shape from "./shape"
import typography from "./typography"

interface BrandObject {
  backgroundColor: string
  color: string
}
interface ConvergeObject {
  backgroundColor: string
  color: string
}
interface ConvergeDestinationObject {
  backgroundColor: string
  color: string
}
interface Gradient {
  blue: string
  red: string
  purple: string
}
export interface Brand {
  facebook: BrandObject
  google: BrandObject
  sms: BrandObject
  email: BrandObject
  omnichannel: BrandObject
  wallet: BrandObject
  messenger: BrandObject
  ticketrev: BrandObject
  manychat: BrandObject
  zenGlobal: BrandObject
  webhook: BrandObject
  wait: BrandObject
  goal: BrandObject
  stage: BrandObject
  note: BrandObject
  conditionalSplit: BrandObject
  oneTimeCampaign: BrandObject
  automatedCampaign: BrandObject
  enrichmentCampaign: BrandObject
  acquisitionCampaign: BrandObject
  outboundDirection: BrandObject
  inboundDirection: BrandObject
  omniDirection: BrandObject
}

export interface Converge {
  shopify: ConvergeObject
  woocommerce: ConvergeObject
  zapier: ConvergeObject
  bigcommerce: ConvergeObject
  wordpress: ConvergeObject
  scriptTag: ConvergeObject
}

export interface ConvergeDestination {
  facebook: ConvergeDestinationObject
  googleAds: ConvergeDestinationObject
  googleAnalytics: ConvergeDestinationObject
  snapchat: ConvergeDestinationObject
  pinterest: ConvergeDestinationObject
  tiktok: ConvergeDestinationObject
}

declare module "@mui/material/styles/createPalette" {
  interface Palette {
    warning: PaletteColor
    success: PaletteColor
    info: PaletteColor
    gradient: Gradient
    brand: Brand
    converge: Converge
    convergeDestination: ConvergeDestination
    border: string
    divider: string
  }
  interface PaletteOptions {
    warning?: PaletteColorOptions
    success?: PaletteColorOptions
    info?: PaletteColorOptions
  }
}

/* declare module '@material-ui/core/styles/createMuiTheme' {
  interface Theme {
    border: string
    divider: string
  }
  interface ThemeOptions {
    border?: string
    divider?: string
  }
} */

// defaults - https://mui.com/material-ui/customization/breakpoints/
export const breakpointValues = {
  xs: 0,
  sm: 600,
  md: 900,
  lg: 1200,
  xl: 1536,
}

const theme = createTheme({
  palette,
  typography,
  components: {
    ...overrides,
    MuiToggleButtonGroup: {
      styleOverrides: {

      }
    },
    MuiToggleButton: {
      styleOverrides: {
        root: ({ theme }) => ({
          color: 'inherit'
        })
      }
    },
    MuiChip: {
      styleOverrides:
      {
        root: ({ theme }) => ({
          [theme.breakpoints.only("xl")]: {
            fontSize: "1.1rem",
            lineHeight: "1.3rem",
          },
          [theme.breakpoints.only("lg")]: {
            fontSize: "0.9rem",
            lineHeight: "1.2rem",
          },
          [theme.breakpoints.down("lg")]: {
            fontSize: "0.7rem",
            lineHeight: "1rem",
          },
        }),
      }
    }
  },
  shape,
  breakpoints: {
    values: breakpointValues,
  },
})

theme.typography.h1 = {
  [theme.breakpoints.only("xl")]: {
    fontSize: "2.6rem",
    lineHeight: "2.8rem",
  },
  [theme.breakpoints.only("lg")]: {
    lineHeight: "2.2rem",
    // lineHeight: "1rem",
  },
  [theme.breakpoints.down("lg")]: {
    fontSize: "1.6rem",
    lineHeight: "1.9rem",
  },
}

theme.typography.h2 = {
  [theme.breakpoints.only("xl")]: {
    fontSize: "1.8rem",
    lineHeight: "2.2rem",
    // lineHeight: "1rem",
  },
  [theme.breakpoints.only("lg")]: {
    lineHeight: "2rem",
    // lineHeight: "1rem",
  },
  [theme.breakpoints.down("lg")]: {
    fontSize: "1.5rem",
    lineHeight: "1.7rem",
  },
}

theme.typography.h3 = {
  [theme.breakpoints.only("xl")]: {
    fontSize: "1.4rem",
    fontWeight: 500,
  },
  [theme.breakpoints.down("lg")]: {
    fontSize: "1.3rem",
  },
}

export default theme
